import { useCallback, useMemo } from 'react';
import { usePersistedState } from '~/hooks/usePersistedState';

const HOUR_IN_MS = 60 * 60 * 1000; // 60 minutes

export const useRecentlyAddedTalent = () => {
  const [recentTalent, setRecentTalent] = usePersistedState<{
    timestamp: number;
  } | null>('recentlyTalentAdded', null);

  // Check if talent was recently added (within last 60 minutes)
  const hasRecentTalentAdded = useMemo(() => {
    if (!recentTalent) return false;
    return Date.now() - recentTalent.timestamp < HOUR_IN_MS;
  }, [recentTalent]);

  // Add talent (single or bulk) - just update timestamp
  const setRecentTalentAddedTimestamp = useCallback(() => {
    setRecentTalent({ timestamp: Date.now() });
  }, [setRecentTalent]);

  // Clear the recent talent timestamp
  const clearRecentTalentAddedTimestamp = useCallback(() => {
    setRecentTalent(null);
  }, [setRecentTalent]);

  return {
    // Data
    hasRecentTalentAdded,

    // Actions
    setRecentTalentAddedTimestamp,
    clearRecentTalentAddedTimestamp,
  };
};
